// extracted by mini-css-extract-plugin
module.exports = {"infoWrap":"InvoiceInfo_infoWrap__3hIB3","labelCentered":"InvoiceInfo_labelCentered__1D9zw","radioLabel":"InvoiceInfo_radioLabel__bnywU","labelAlt":"InvoiceInfo_labelAlt__1Zu_x"};